import { makeAutoObservable, action } from 'mobx'

export class UIStore {
  leftPanelWidth = 320
  rightPanelWidth = 380
  isResizingLeft = false
  isResizingRight = false

  constructor() {
    makeAutoObservable(this, {
      setLeftPanelWidth: action,
      setRightPanelWidth: action,
      startResizingLeft: action,
      startResizingRight: action,
      stopResizing: action,
      handleMouseMove: action
    })
  }

  setLeftPanelWidth(width: number) {
    this.leftPanelWidth = Math.max(200, Math.min(600, width))
  }

  setRightPanelWidth(width: number) {
    this.rightPanelWidth = Math.max(280, Math.min(800, width))
  }

  startResizingLeft() {
    this.isResizingLeft = true
    document.body.style.cursor = 'col-resize'
    document.body.style.userSelect = 'none'
  }

  startResizingRight() {
    this.isResizingRight = true
    document.body.style.cursor = 'col-resize'
    document.body.style.userSelect = 'none'
  }

  stopResizing() {
    this.isResizingLeft = false
    this.isResizingRight = false
    document.body.style.cursor = ''
    document.body.style.userSelect = ''
  }

  handleMouseMove(e: MouseEvent) {
    if (this.isResizingLeft) {
      this.setLeftPanelWidth(e.clientX)
    }
    if (this.isResizingRight) {
      this.setRightPanelWidth(window.innerWidth - e.clientX)
    }
  }
}

